import request from '@/utils/request'
/**
* @fileOverview 作品报名、我的作品、参赛作品
*/

/**
* @description 创建编辑用户前置数据
*/
export function storeBefore(type) {
  return request({
    url: `/products/storeBefore?type=${type}`,
    method: 'get'
  })
}

/**
* @description 作品报名验证，验证当前是否有奖项可以报名
*/
export function checkAward() {
  return request({
    url: '/products/checkAward',
    method: 'get'
  })
}

/**
* @description 作品报名
* @param {string} data.category_id 类别
* @param {string} data.name_cn 作品名称中文
* @param {string} data.name_en 作品名称英文
* @param {string} data.type_cn 作品类型中文
* @param {string} data.type_en 作品类型英文
* @param {string} data.market_launch 发售年份
* @param {string} data.description_cn 作品简介中文
* @param {string} data.manufacturer_address_id 制造商地址
* @param {string} data.submission 复评寄送形式
* @param {string} data.width 宽度
* @param {string} data.height 高度
* @param {string} data.depth 深度
* @param {string} data.submitted_items 提交个数
* @param {string} data.commission_id 推荐码
* @param {array} data.old_images 图片
* @param {array} data.images 图片
* @param {object} data.manufacturer_address 制造商地址详情，有id的话是编辑 没有就是新增
* @param {string} data.one_design_address 设计方 厂内设计地址id
* @param {string} data.two_design_address 设计方 外部设计工作室id
* @param {string} data.three_design_address 设计方 外聘设计师id
*/
export function editCheckAward(data) {
  return request({
    url: '/products/checkAward',
    method: 'post',
    data
  })
}

/**
* @description 作品详情
* @param {string} id 作品id
* @param {string} type 赛事类型（1或2）
*/
export function products(id, type) {
  const url = type ? `/products/${id}?type=${type}` : `/products/${id}`
  return request({
    url,
    method: 'get'
  })
}

/**
* @description 作品图片上传
* @param {string} id 作品id
* @param {array} data.images base64图片数组
* @param {array} data.old_images url字符串图片数组
* @param {string} data.type type值，不一定传
*/
export function productsUploadImage(id, data) {
  return request({
    url: `/products/uploadImage/${id}`,
    method: 'put',
    data
  })
}

/**
* @description 作品编辑保存
* @param {string} data.category_id 类别
* @param {string} data.name_cn 作品名称中文
* @param {string} data.name_en 作品名称英文
* @param {string} data.type_cn 作品类型中文
* @param {string} data.type_en 作品类型英文
* @param {string} data.market_launch 发售年份
* @param {string} data.description_cn 作品简介中文
* @param {string} data.manufacturer_address_id 制造商地址
* @param {string} data.submission 复评寄送形式
* @param {string} data.width 宽度
* @param {string} data.height 高度
* @param {string} data.depth 深度
* @param {string} data.submitted_items 提交个数
* @param {string} data.commission_id 推荐码
* @param {array} data.old_images 图片
* @param {array} data.images 图片
* @param {object} data.manufacturer_address 制造商地址详情，有id的话是编辑 没有就是新增
* @param {string} data.one_design_address 设计方 厂内设计地址id
* @param {string} data.two_design_address 设计方 外部设计工作室id
* @param {string} data.three_design_address 设计方 外聘设计师id
*/
export function eidtProducts(id, data, type) {
  console.log('eidtProducts')
  return request({
    url: id ? `/products/${id}?type=${type}` : `/products?type=${type}`,
    method: id ? 'patch' : 'post',
    data
  })
}

export function awards() {
  return request({
    url: '/awards/lists',
    method: 'get'
  })
}

/**
* @description 作品完成注册
* @param {string} id 作品ID（0表示新建）
* @param {object} data 作品数据
* @param {string} data.category_id 类别
* @param {string} data.name_cn 作品名称中文
* @param {string} data.type_cn 作品类型中文
* @param {string} data.commission_id 推荐码
* @param {array} data.product_label 产品标签
* @param {array} data.user_label 用户标签
* @param {string} data.channel_type 渠道类型
* @param {string} data.channel_remark 渠道备注
* @param {string} data.market_launch 发售年份
* @param {string} data.description_cn 作品简介中文
* @param {string} data.width 宽度
* @param {string} data.height 高度
* @param {string} data.depth 深度
* @param {array} data.design_address 设计方地址ID数组
* @param {array} data.videos 视频URL数组
* @param {string} type 赛事类型（1或2）
*/
export function putProducts(id, data, type) {
  return request({
    url: id ? `/products/${id}?type=${type}` : `/products/0?type=${type}`,
    method: 'put',
    data
  })
}

/**
* @description 我的作品
* @param {string} params.search 搜索条件
*/
export function myProducts(params) {
  return request({
    url: '/products',
    method: 'get',
    params
  })
}

/**
* @description 列表前置数据
*/
export function productsIndexBefore() {
  return request({
    url: '/products/indexBefore',
    method: 'get'
  })
}

/**
* @description 参赛作品列表搜索 + 下载
* @param {string} data.country 国家
* @param {string} data.province 省份
* @param {string} data.city 城市
* @param {string} data.award_id 奖项ID
* @param {string} data.pi_code 参赛编号
* @param {string} data.name_cn 作品名称中文
* @param {string} data.type_cn 作品类型中文
* @param {string} data.name 申请人姓名
* @param {string} data.email 申请人邮箱
* @param {number} data.register_status 注册状态
* @param {string} data.delivery_status 递交状态
* @param {number} data.category_id 类别ID
* @param {string} data.manager_id 客户经理ID
* @param {string} data.company_info 单位信息
* @param {string} data.pay_status 支付状态
* @param {string} data.search_type 查询类型：search 导出所有excel export_excel_all 导出查询结果excel export_excel 导出所有pdf export_pdf_all 导出查询结果pdf export_pdf 导出small pdf-export_pdf_small
* @param {number} data.page 页码
* @param {number} data.is_award 1获奖作品 0参赛作品
*/
export function searchs(data) {
  return request({
    url: '/searchs',
    method: 'post',
    data
  })
}

/**
* @description 查询前置数据,参数列表同上
*/
export function searchsIndexBefore() {
  return request({
    url: '/searchs/indexBefore',
    method: 'get'
  })
}

/**
* @description 删除作品
*/
export function deleteSearchs(id) {
  return request({
    url: `/searchs/${id}`,
    method: 'delete'
  })
}

/**
* @description 下载作品内容
*/
export function searchsDownload(id) {
  return request({
    url: `/searchs/download/${id}`,
    method: 'get'
  })
}

/**
* @description 更改作品注册状态
* @param {number} data.id  1
* @param {number} data.status  1
*/
export function searchsChangeStatus(data) {
  return request({
    url: `/searchs/changeStatus`,
    method: 'post',
    data
  })
}

/**
* @description 作品确认
* @param {number} id 作品id
* @param {number} data.name_cn  作品名称(中文)
* @param {number} data.name_en  作品名称(英文)
* @param {number} data.height  高度
* @param {number} data.width  宽度
* @param {number} data.depth 厚度
* @param {number} data.design_addrss  设计方信息，姓和名
* @param {number} data.confirmation_status 1作品确认
*/
export function productsConfirmUpdate(id, data) {
  return request({
    url: `/products/confirmUpdate/${id}`,
    method: 'put',
    data
  })
}

/**
* @description 作品反馈
* @param {number} id 作品id
* @param {number} data.feedback 反馈内容
*/
export function productsSendOut(id, data) {
  return request({
    url: `/products/sendOut/${id}`,
    method: 'put',
    data
  })
}

/**
* @description 作品确认文件上传
* @param {string} id 作品id
* @param {array} data.type 1-3D模型文件   2-产品丝印图
* @param {array} data.file
*/
export function productsFileUpload(id, data) {
  return request({
    url: `/products/fileUpload/${id}`,
    method: 'post',
    data
  })
}

/**
* @description 作品确认删除文件
* @param {string} id 文件id
*/
export function productsDeleteFile(id) {
  return request({
    url: `/products/deleteFile/${id}`,
    method: 'delete'
  })
}

/**
* @description 作品视频上传
* @param {string} id 作品id
* @param {object} data 上传数据
* @param {array} data.videos 视频文件数组
* @param {array} data.old_videos 已存在视频URL数组
*/
export function productsUploadVideo(id, data) {
  return request({
    url: `/products/uploadVideo/${id}`,
    method: 'put',
    data
  })
}

/**
 * @description 统一的初评详情接口 - 用于初筛、初评、复审详情页
* @param {string} id 作品id
* @param {string} user_id 用户id
 * @param {string} type 初评类型 (0-初筛, 1-初评, 2-复评)
*/
export function getProductReviewDetail(id, user_id, type) {
  return request({
    url: `/reviews/product/${id}/${user_id}/${type}`,
    method: 'get'
  })
}

/**
 * @description 下载作品
 * @param {string} id 作品id
 */
export function productsWordExport(id) {
  return request({
    url: `/products/wordExport/${id}`,
    method: 'get'
  })
}
export function deleteProduct(id) {
  return request({
    url: `/products/${id}`,
    method: 'delete'
  })
}
